import { render, staticRenderFns } from "./TableSimple.vue?vue&type=template&id=9dce1492&scoped=true&"
import script from "./TableSimple.vue?vue&type=script&lang=js&"
export * from "./TableSimple.vue?vue&type=script&lang=js&"
import style0 from "./TableSimple.vue?vue&type=style&index=0&id=9dce1492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dce1492",
  null
  
)

export default component.exports